"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
require("typeface-roboto-mono");
const Typography_1 = tslib_1.__importDefault(require("@mui/material/Typography"));
const fontFamily = ["'Roboto Mono'", "'monospace'"].join(",");
const getStyles = () => ({
    body1: { fontFamily },
    body2: { fontFamily },
    caption: { fontFamily },
    h1: { fontFamily },
    h2: { fontFamily },
    h3: { fontFamily },
    h4: { fontFamily },
    h5: { fontFamily },
    h6: { fontFamily },
    subtitle1: { fontFamily },
});
const TypographyMonospace = (props) => {
    const styles = getStyles();
    return React.createElement(Typography_1.default, { ...{ ...props, sx: { ...styles, ...props?.sx } } });
};
exports.default = TypographyMonospace;
